"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _NoticeError = _interopRequireDefault(require("./NoticeError"));
var _NoticeUnavailable = _interopRequireDefault(require("./NoticeUnavailable"));
var _NoticeEmptySearch = _interopRequireDefault(require("./NoticeEmptySearch"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  description: '',
  title: '',
  name: '',
  toAction: null,
  toActionText: '',
  noSpace: false,
  className: ''
};
function Notice(props) {
  const {
    description,
    name,
    title,
    toAction,
    toActionText,
    noSpace,
    className
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    colors
  } = (0, _react2.useTheme)();
  const color = (0, _react.useMemo)(() => colors.FONT.DESCRIPTION, [colors]);
  const showButton = (0, _react.useMemo)(() => toActionText === null || toActionText === void 0 ? void 0 : toActionText.length, [toActionText]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    noSpace: noSpace,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: name,
    size: 50,
    color: color
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "title-4",
    size: 22,
    color: color,
    children: title
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: color,
    align: "center",
    children: description
  }), showButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "link",
    onClick: toAction,
    children: toActionText
  }) : null);
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  justify-items: center;\n  gap: 10px;\n  margin: ", "px 0;\n\n  .material-icons {\n    margin-bottom: 10px;\n  }\n\n  button {\n    margin-top: 10px;\n  }\n"])), _ref => {
  let {
    noSpace
  } = _ref;
  return noSpace ? 0 : 40;
});
Notice.Error = _NoticeError.default;
Notice.Unavailable = _NoticeUnavailable.default;
Notice.EmptySearch = _NoticeEmptySearch.default;
var _default = exports.default = Notice;